module.exports = __webpack_public_path__ + "assets/img/18_1835_big.61c4651e.jpg";